import styled from 'styled-components/macro';

const DontPrint = styled.div`
  flex: 0 1 auto;

  @media print {
    display: none;
  }

  .k-pdf-export & {
    display: none !important;
  }
`;

export default DontPrint;
